/**
 * Homescreen / phone-width tap target for the www SPA chrome
 * (cookie banner, social icons, Sign In). WCAG 2.5.5 / iOS 44pt.
 */
export const WWW_TAP_TARGET_MIN_PX = 44;

/** CSS class in `src/index.css` — `min-width` / `min-height` 44px. */
export const WWW_TAP_TARGET_CLASS = 'tap-target-min';
